import { defineMessages } from 'react-intl'

const scope = `procurify.expense.AttachableTravelTicketSelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Please select an option',
  },
  travelTicketLabel: {
    id: `${scope}.travelTicketLabel`,
    defaultMessage: 'Travel #{id} - {purpose}',
  },
})
